export class TextDirectionController {

    public textDirection: string = 'rtl';

    constructor() {
        this.CheckDirection();
    }

    public CheckDirection(): void {
        const lang = sessionStorage.getItem('lang');
        this.textDirection = 'ltr'
        if (lang === 'ar') { 
            this.textDirection = 'rtl';
        } else {
            this.textDirection = 'ltr';
        }
    }
}